module.exports = __webpack_public_path__ + "resources/img/img_security_TLS_SSL_certificate1_m_en.eabbe8c3f2edff693241e9ea06cb2cff.png";